import { render, staticRenderFns } from "./hero-marquee.vue?vue&type=template&id=303cdbf8&scoped=true&lang=pug"
import script from "./hero-marquee.vue?vue&type=script&lang=coffee"
export * from "./hero-marquee.vue?vue&type=script&lang=coffee"
import style0 from "./hero-marquee.vue?vue&type=style&index=0&id=303cdbf8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303cdbf8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResponsiveCraftVisual: require('/opt/build/repo/site/node_modules/@bkwld/cloak/components/responsive-craft-visual.vue').default,Squircle: require('/opt/build/repo/site/components/globals/squircle/index.vue').default,Wysiwyg: require('/opt/build/repo/site/node_modules/@bkwld/cloak/components/wysiwyg.coffee').default,ButtonVideoLauncher: require('/opt/build/repo/site/components/globals/button-video-launcher.vue').default,BtnCraft: require('/opt/build/repo/site/components/globals/btn/craft.vue').default,VideoCard: require('/opt/build/repo/site/components/globals/video-card.vue').default})
